/*! Rappid v2.3.0 - HTML5 Diagramming Framework - TRIAL VERSION

Copyright (c) 2015 client IO

 2018-05-26 


This Source Code Form is subject to the terms of the Rappid Trial License
, v. 2.0. If a copy of the Rappid License was not distributed with this
file, You can obtain one at http://jointjs.com/license/rappid_v2.txt
 or from the Rappid archive as was distributed by client IO. See the LICENSE file.*/

import App from "../App";

App.config = App.config || {};

App.config.selection = {
	handles: [
		{
			name: "remove",
			position: "nw",
			events: {
				pointerdown: function(evt) {
					var selectedElements = this.collection.toArray();
					selectedElements = selectedElements.filter(selectedElement => {						
						return selectedElement.get("type") !== "rankerx.MoneySite"
					});
					this.cancelSelection(),
						this.options.graph.removeCells(selectedElements, {
							selection: this.cid
						});
				}
			},
			attrs: {
				".handle": {
					"data-tooltip-class-name": "small",
					"data-tooltip": "Click to remove the selected projects",
					"data-tooltip-position": "right",
					"data-tooltip-padding": 15
				}
			}
		},
		{
			name: "rotate",
			position: "sw",
			events: {
				pointerdown: "startRotating",
				pointermove: "doRotate",
				pointerup: "stopBatch"
			},
			attrs: {
				".handle": {
					"data-tooltip-class-name": "small",
					"data-tooltip": "Click and drag to rotate the selected projects",
					"data-tooltip-position": "right",
					"data-tooltip-padding": 15
				}
			}
		},
		// {
		// 	name: "clone",
		// 	position: "se",
		// 	events: {
		// 		pointerdown: "startCloning",
		// 		pointermove: "doClone",
		// 		pointerup: "stopCloning"
		// 	},
		// 	attrs: {
		// 		".handle": {
		// 			"data-tooltip-class-name": "small",
		// 			"data-tooltip": "Click and drag to clone the object",
		// 			"data-tooltip-position": "left",
		// 			"data-tooltip-padding": 15
		// 		}
		// 	}
		// },		
		// {
		// 	name: "resize",
		// 	position: "se",
		// 	events: {
		// 		pointerdown: "startResizing",
		// 		pointermove: "doResize",
		// 		pointerup: "stopBatch"
		// 	},
		// 	attrs: {
		// 		".handle": {
		// 			"data-tooltip-class-name": "small",
		// 			"data-tooltip": "Click and drag to resize the selected projects",
		// 			"data-tooltip-position": "left",
		// 			"data-tooltip-padding": 15
		// 		}
		// 	}
		// }
	]
};
